import { Box, Grid } from "@mui/material";
import { ClaimBasedComponent } from "components/ClaimBasedComponent";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { ClaimResource } from "types/claimTypes";

const CertificatesPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    certificateListUrl,
    certificateThemesUrl,
    certificateTemplatesUrl,
  } = useGlobalContext();

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <ClaimBasedComponent requestedClaims={[ClaimResource.Certificates]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "menubarCertificates" })}
              url={certificateListUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.CertificateThemes]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "menubarThemes" })}
              url={certificateThemesUrl()}
            />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.CertificateTemplates]}>
          <Grid item xs={12} sm={4}>
            <NavCard
              title={t({ id: "menubarTemplates" })}
              url={certificateTemplatesUrl()}
            />
          </Grid>
        </ClaimBasedComponent>
      </Grid>
    </Box>
  );
};

export default CertificatesPage;
